module.exports = __webpack_public_path__ + "static/media/tul_logo.b7c2592f.svg";